@if (breadcrumbs().length > 0) {
  <nav
    class="flex items-center px-[40px] pt-10 pb-1 text-sm "
    aria-label="Breadcrumb"
  >
    <ol class="flex items-center gap-1.5">
      @for (item of breadcrumbs(); track $index) {
        <li class="flex items-center gap-1.5">
          @if (!isLastItem($index)) {
            <a
              [routerLink]="item.url"
              class="flex items-center gap-1.5"
            >
              @if (item.label.toLowerCase() === 'home') {
                <img 
                  src="/home.png" 
                  alt="Home" 
                  class="h-[20px] w-[20px]"
                />
              }
              @if (item.label && item.label.toLowerCase() !== 'home') {
                <span class="text-[15px] font-light" >{{ item.label }}</span>
              }
            </a>
            <span class="flex items-center" aria-hidden="true">
              <img 
                src="/chevron-right.png" 
                alt="" 
                class="h-[12px] w-[12px]"
              />
            </span>
          } @else {
            <span class="flex items-center gap-1.5" aria-current="page">
              @if (item.label && item.label.toLowerCase() !== 'home') {
                <span class="text-[15px] font-medium ">{{ item.label }}</span>
              }
            </span>
          }
        </li>
      }
    </ol>
  </nav>
}

